import type { DocEntityType } from "building-types/doc/docEntityTypes";
import type { AllDocTableFieldNames } from "../docTableFieldNames";

export const docEntityTypeToDocTableName = {
  GROUP: "groups",
  COMPONENT: "components",
  COMPONENT_INSTANCE: "componentInstances",
  DOC_REF: "docRefs",
  LEVEL: "levels",
  COMPOSITE_LEVEL: "compositeLevels",
  BLOCK: "blocks",
  ROOM: "rooms",
  STAIR_SYSTEM: "stairSystems",
  STAIR_BLOCK: "stairBlocks",
  RAILING: "railings",
  FREEFORM_WALL: "freeformWalls",
  PRESET: "presets",
  ROOF_SYSTEM: "roofSystems",
  ROOF: "roofs",
  ROOF_VOLUME: "roofVolumes",
  FOUNDATION_SYSTEM: "foundationSystems",
  FOUNDATION: "foundations",
  UNDERLAY: "underlays",
  ASSET: "assets",
  REFERENCE_GEOM: "referenceGeom",
  ELEVATION: "elevations",
  PALETTE: "palettes",
  SETTINGS: "settings",
  SETTINGS_SET: "settingsSets",
  ENTITY_SETTINGS: "entitySettings",
  OPTION_TEMPLATE: "optionTemplates",
  SHEET: "sheets",
  DRAWING_REF: "drawingRefs",
  OPTION_SET_OVERRIDES: "optionSetOverrides",
  OPTION_SET: "optionSets",
  INSTANCE_OPTION_SET: "instanceOptionSets",
  OPTION_RULE: "optionRules",
  OPTION_EFFECT: "optionEffects",
  OPTION_LOCK: "optionLocks",
  PROP_INSTANCE: "propInstances",
  PROFILE: "profiles",
  RAILING_SETTING: "railingCatalog",
  PROP: "propAttributes",
  CASEWORK: "casework",
  CEILING: "ceilings",
  EDGE_BEHAVIOR: "edgeBehaviors",
  WALL_PLANE_ASSEMBLY: "wallPlaneAssemblies",
  WALL_PLANE_FILTER: "wallPlaneFilters",
  WALL_PLANE_RULE: "wallPlaneRules",
  WALL_PLANE_TRIM: "wallPlaneTrims",
  OPENING: "openings",
  ANNOTATION: "annotation",
  FACADE: "facades",
  DORMER: "dormers",
  SITE: "sites",
  SITE_SHAPE: "siteShapes",
  MODIFIER: "modifiers",
  MEASUREMENT: "measurements",
  VIEW_3D: "view3Ds",
  ELEVATION_VIEW: "elevationViews",
  PLAN_VIEW: "planViews",
  ROOM_LAYOUT: "roomLayouts",
  ROOM_LAYOUT_INSTANCE: "roomLayoutInstances",
  SKYLIGHT: "skylights",
  ROOF_OPENING: "roofOpenings",
  COLUMN: "columns",
  FLOOR: "floors",
  FLOOR_FINISH: "floorFinishes",
  FACADE_SPAN_STRATUM: "facadeSpanStrata",
  FACADE_SWEEP_STRATUM: "facadeSweepStrata",
  RAILING_POST: "railingPosts",
  EDGE_MODIFIER: "edgeModifiers",
  ELECTRICAL_DEVICE: "electricalDevices",
  ELECTRICAL_LAYOUT: "electricalLayouts",
  PLAN_SET_TEMPLATE: "planSetTemplates",
  CONTENT_TEMPLATE: "contentTemplates",
  CONTENT_TEMPLATE_INSTANCE: "contentTemplateInstances",
  CONTENT_REPLICATOR: "contentReplicators",
  LOCAL_PARAMETER: "localParameters",
  GLOBAL_PARAMETER: "globalParameters",
  SYSTEM_PARAMETER: undefined,
  VIEWPORT: "viewports",
  VIEW_TEMPLATE: "viewTemplates",
  VIEW_TEMPLATE_OVERRIDE: "viewTemplateOverrides",
  DATA_TABLE: "dataTables",
  DATA_SEQUENCE: "dataSequences",
  SECTION_VIEW: "sectionViews",
  SELECTOR: "selectors",
  VIEW_OVERRIDE: "viewOverrides",
  VIEW_SELECTOR: "viewSelectors",
  PLAN_SET_TEMPLATE_CONFIG: "planSetTemplateConfigs",
  AUTO_DIMENSION: undefined,
  LABEL: "labels",
  REPORTABLE_UNIT_DESIGNATION: "reportableUnitDesignations",
  EFFECT: "effects",
  DATUM: "datums",
  RULE_BASED_SELECTOR: "ruleBasedSelectors",
  RULE_BASED_SELECTOR_INSTANCE: "ruleBasedSelectorInstances",
  ROOF_SIDE: undefined,
  OPTION: undefined,
  CATALOG_ITEM: undefined,
  ELECTRICAL_RULE: undefined,
  SHAPE: undefined,
  EDGE: undefined,
  VERTEX: undefined,
  EDIT_MODE: undefined,
  GENERATED_ENTITY: undefined,
  INDETERMINATE_ENTITY_TYPE: undefined,
  FRAMING_COMPONENT: "framingComponents",
  CIP_COMPONENT: "cipComponents",
  MASONRY_COMPONENT: "masonryComponents",
  SHEATHING_COMPONENT: "sheathingComponents",
  FOUNDATION_ASSEMBLY: "foundationAssemblies",
  FOUNDATION_COMPONENT: "foundationComponents",
  HEADER_ASSEMBLY: "headerAssemblies",
  FRAME_FLOOR_ASSEMBLY: "frameFloorAssemblies",
  SLAB_FLOOR_ASSEMBLY: "slabFloorAssemblies",
  SLAB_COMPONENT: "slabComponents",
  FLOOR_SYSTEM: "floorSystems",
  FLOOR_BAY: undefined,
  FLOOR_PERIMETER_OPENING: undefined,
  FLOOR_SPLIT_LINE: undefined,
  STAIR_SETTING: "stairCatalog",
} as const satisfies Record<DocEntityType, AllDocTableFieldNames | undefined>;
